import {Component, Inject, OnInit, Optional} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Race, RaceType} from '../../../core/model/resources/race';
import {RaceApiService, RaceSearchType} from '../../../core/services/race-api.service';
import {MessageDialogComponent} from '../message-dialog/message-dialog.component';

@Component({
    selector: 'app-race-select-dialog',
    templateUrl: './race-select-dialog.component.html',
    styleUrls: ['./race-select-dialog.component.scss'],
    standalone: false
})
export class RaceSelectDialogComponent implements OnInit {

  searchType?: RaceSearchType;
  displayedColumns = ['id', 'title'];

  title?: string;
  runtesId: string = '';
  totalRaceId: string = '';
  moshicomRaceId: number | null = null;

  races: Race[] = [];

  static async createSelectMoshicomRaceDialog(dialog: MatDialog): Promise<Race> {
    return await this.createDialog(dialog, 'e-moshicom大会を検索', RaceSearchType.SEARCH_BY_MOSHICOM_ID);
  }

  static async createSelectTotalRaceDialog(dialog: MatDialog): Promise<Race> {
    return await this.createDialog(dialog, 'RUNTES大会を検索', RaceSearchType.SEARCH_BY_TOTAL_RACE_ID);
  }

  static async createSelectNotImportedRaceDialog(dialog: MatDialog): Promise<Race> {
    return await this.createDialog(dialog, '未取込の大会を検索', RaceSearchType.SEARCH_BY_NOT_IMPORTED);
  }

  private static async createDialog(dialog: MatDialog, title: string, searchType: RaceSearchType): Promise<Race> {
    return await dialog.open(RaceSelectDialogComponent, {
      width: '600px',
      maxWidth: '600px',
      data: {
        title,
        searchType
      }
    }).afterClosed().toPromise();
  }

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) private data: { title: string, searchType: RaceSearchType },
    private raceApiService: RaceApiService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<RaceSelectDialogComponent>,
  ) {
  }

  ngOnInit(): void {
    this.title = this.data.title;
    this.searchType = this.data.searchType;
  }

  isSearchTotalRaceId(): boolean {
    return this.searchType === RaceSearchType.SEARCH_BY_TOTAL_RACE_ID;
  }

  isSearchMoshicom(): boolean {
    return this.searchType === RaceSearchType.SEARCH_BY_MOSHICOM_ID;
  }

  isSearchNotImported(): boolean {
    return this.searchType === RaceSearchType.SEARCH_BY_NOT_IMPORTED;
  }

  async search(): Promise<void> {
    let res = null;
    switch (this.searchType) {
      case RaceSearchType.SEARCH_BY_NOT_IMPORTED:
        res = await this.raceApiService.searchNotImportedRaces(this.runtesId);
        break;
      case RaceSearchType.SEARCH_BY_TOTAL_RACE_ID:
        res = await this.raceApiService.searchByTotalRaceId(this.totalRaceId, RaceType.NormalRace);
        break;
      case RaceSearchType.SEARCH_BY_MOSHICOM_ID:
        if (this.moshicomRaceId !== null) {
          res = await this.raceApiService.searchById(this.moshicomRaceId, RaceType.NormalRace, RaceSearchType.SEARCH_BY_MOSHICOM_ID);
        }
        break;
      default:
        break;
    }
    if (!!res && res.success) {
      this.races = this.searchType === RaceSearchType.SEARCH_BY_TOTAL_RACE_ID ?
        res.data.filter((race: any) => race.is_representation) : res.data;
    } else {
      this.races = [];
    }
  }

  onClickRace(race: Race): void {
    if ((this.searchType === RaceSearchType.SEARCH_BY_TOTAL_RACE_ID || this.searchType === RaceSearchType.SEARCH_BY_MOSHICOM_ID)
      && !!race.to_race_id) {
      MessageDialogComponent.createErrorDialog(this.dialog, 'この大会は中止済みのため選択できません。');
      return;
    }

    this.dialogRef.close(race);
  }

}
